var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.cities,"label":_vm.label,"error-messages":_vm.errorMessages,"solo":"","color":"#000080"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})
}
var staticRenderFns = []

export { render, staticRenderFns }